import http from  './axios'

/*人员管理*/
//删除医院用户
export const deletePeople = param =>{return http.post("clinic-manager/manager/delHisUserById",param).then(res=>res.data.data)};
//查询医院人员
export const peopleList = param =>{return http.post("clinic-manager/manager/getHisUsers",param).then(res=>res.data.data)};
//保存医院用户
export const savePeople = param =>{return http.post("clinic-manager/manager/saveHisUser",param).then(res=>res.data.data)};
//修改医院用户信息
export const updPeopleInfo = param =>{return http.post("clinic-manager/manager/updHisUserById",param).then(res=>res.data.data)};
//根据id查询医院用户信息
export const peopleDetail = param =>{return http.post("clinic-manager/manager/selHisUserById",param).then(res=>res.data.data)};
//密码重置
export const pwdReset = param =>{return http.post("clinic-manager/manager/updHisPasswordById",param).then(res=>res.data.data)};
//更改医院用户启用状态
export const peopleStatus = param =>{return http.post("clinic-manager/manager/updHisUserEnable",param).then(res=>res.data.data)};

/*科室管理*/
//删除医院科室
export const deleteClinic = param =>{return http.post("clinic-manager/manager/delHisDepartment",param).then(res=>res.data.data)};
//保存医院科室
export const saveClinic = param =>{return http.post("clinic-manager/manager/saveHisDepartment",param).then(res=>res.data.data)};
//修改医院科室
export const updCLinic = param =>{return http.post("clinic-manager/manager/updHisDepartment",param).then(res=>res.data.data)};
//更改医院科室启用状态
export const clinicStatus = param =>{return http.post("clinic-manager/manager/updHisDepartmentEnable",param).then(res=>res.data.data)};
//查询医院科室
export const clinicList = param =>{return http.post("clinic-manager/manager/getHisDepartment",param).then(res=>res.data.data)};
//查询医院科室详情
export const clinicDetail = param =>{return http.post("clinic-manager/manager/getHisDepartmentById",param).then(res=>res.data.data)};

/*角色管理*/

//查询角色
export const roleList = param =>{return http.post("clinic-manager/manager/getHisRoles",param).then(res=>res.data.data)};
//查询医院角色（下拉）
export const roleSelect = param =>{return http.post("clinic-manager/manager/getHisRole",param).then(res=>res.data.data)};
//删除医院角色
export const deleteRole = param =>{return http.post("clinic-manager/manager/delHisRole",param).then(res=>res.data.data)};
//修改医院角色
export const updRole = param =>{return http.post("clinic-manager/manager/updHisRole",param).then(res=>res.data.data)};
//查询医院菜单
export const hospitalItem = param =>{return http.post("clinic-manager/manager/getHospitalMenu",param).then(res=>res.data.data)};
//更改医院角色启用状态
export const roleStatus = param =>{return http.post("clinic-manager/manager/updHisRoleEnable",param).then(res=>res.data.data)};
//保存医院角色
export const saveRole = param =>{return http.post("clinic-manager/manager/saveHisRole",param).then(res=>res.data.data)};
//根据id查询角色详情
export const roleDetail = param =>{return http.post("clinic-manager/manager/getHisRoleById",param).then(res=>res.data.data)};



// WEBPACK FOOTER //
// ./src/api/system.js